import axios from "axios";

const Url = process.env.REACT_APP_URl;

export const UpdateProfileService = (profile: any) => {
  const apiUrl = Url + "/updateprofile";
  return axios.put(apiUrl, profile).then((response) => {
    return response.data;
  })

}

export const GetCompanyProfile = () => {
  const apiUrl = Url + "/company";
  return axios.get(apiUrl, {
    headers: {
      "Authorization": "Bearer " + localStorage.getItem("usertoken")
    }
  }).then((response) => {
    return response.data;
  })
}

export const UpdateCompanyProfile = (profile: any, id: any) => {
  const apiUrl = Url + "/company";
  return axios.put(apiUrl + "/" + id, profile, {
    headers: {
      "Authorization": "Bearer " + localStorage.getItem("usertoken")
    }
  }).then((response) => {
    return response.data;
  })

}

export const GetCompanyDesc = async () => {
  const apiUrl = Url + "/getcompanydesc";
  const response = await axios.get(apiUrl, {
    headers: {
      "Authorization": "Bearer " + localStorage.getItem("usertoken")
    }
  })
  return response.data;
}

export const UpdateCompanyDesc = async (value: any) => {
  const apiUrl = Url + "/updatecompanydesc";
  const response = await axios.post(apiUrl, value, {
    headers: {
      "Authorization": "Bearer " + localStorage.getItem("usertoken")
    }
  })
  return response.data;
}

export const GetUserProfile = async () => {
  const apiUrl = Url + "/get_Profile";
  const response = await axios.get(apiUrl, {
    headers: {
      "Authorization": "Bearer " + localStorage.getItem("usertoken")
    }
  })
  return response.data;
}

export const UpdateUserProfile = async (obj: any) => {
   const apiUrl = Url + "/Update_Profile";
  const response = await axios.put(apiUrl,obj, {
    headers: {
      "Authorization": "Bearer " + localStorage.getItem("usertoken")
    }
  })
  return response.data;
}